import { Module } from 'vuex';
import { State } from '@/store/models';
import { Investment } from '@/store/models/investment';
import { Asset } from '@/store/models/asset';

export interface InvestmentsArray<T> extends Array<T> {
  totalLength?: number;
}

export default <Module<Investment[], State>>{
  state: [],
  mutations: {},
  actions: {},
  getters: {
    investmentHasPaidPayments: (state, getters): Function => (id: string): boolean => !!getters.getPaidPaymentsByInvestmentId(id).length,
    investmentHasPaidPaymentsType: (state, getters): Function => (id: string): boolean => !!getters.getPaidPaymentsByInvestmentType(id).length,
    investmentsLoadMore: (state, getters): Function => (position: number): Investment[] => {
      const tempInvestments = getters.getInvestmentsNonDeletedAsset as Investment[];
      const paidInvestments = tempInvestments.filter((investment: Investment): boolean => getters.investmentHasPaidPayments(investment.id));
      const investments: InvestmentsArray<any> = paidInvestments.slice(0, position > tempInvestments.length ? tempInvestments.length : position);

      investments.totalLength = paidInvestments.length;

      return investments;
    },
    // Since we cannot do a proper 'join' to get invesments with conditioned asset, we need to do it client side
    getInvestmentsNonDeletedAsset: (state): Investment[] => state.filter(
      (investment): boolean => !!investment.asset.id && !(investment.asset as Asset).deleted && (investment.asset as Asset).published,
    ),
    getInvestmentById: (state): Function =>
      (id: string): Investment | undefined =>
        state.find((investment): boolean => investment.id === id),
    getInvestmentByAsset: (state): Function =>
      (assetId: string): Investment | undefined =>
        state.find((investment): boolean => investment.asset.id === assetId),
    // Get the number of investments that have at least one paid payment
    getLengthPaidInvestments: (state, getters): number => state.filter(
      (investment): boolean => getters.investmentHasPaidPayments(investment.id),
    ).length,
    // Get the total Euro invested from all investments (if status of payment is 'paid')
    getTotalInvested: (state): number =>
      state.reduce((investmentA, investmentB): number => investmentA + (investmentB.paidEuroTotal || 0) + (investmentB.receivedEuroTotal || 0), 0),
    getSharesTotalInvested: (state): number =>
      state.reduce((investmentA, investmentB): number => investmentA + (investmentB.boughtSharesTotal || 0) + (investmentB.receivedSharesTotal || 0), 0),
    getTotalEarnings: (state): number =>
      state.reduce((investmentA, investmentB): number => investmentA + (investmentB.totalEuroEarnings || 0), 0),
    getTotalCompensation: (state): number =>
      state.reduce((investmentA, investmentB): number => (
        investmentA +
          (((investmentB.boughtSharesTotal || 0) + (investmentB.receivedSharesTotal || 0)) * ((investmentB.asset as Asset).type === 'tree'
            ? 44
            : (investmentB.asset as Asset).type === 'gras'
              ? 55
              : 46))
      ), 0),
  },
};
